/**
 * Random variables
 */
export const HOME_ROUTE_PATH = 'home'
export const LOGIN_ROUTE_PATH = 'login'
export const ADMIN_ROLE = 'certAdmin'
